import { Component, ComponentRef, EventEmitter, Input, Output } from '@angular/core';
import { BaseModalService } from '@app/core/services/base-modal.service';
import { PersonaModalComponent } from '@app/layout/components/persona-modal/persona-modal.component';
import { Speaker } from '@app/shared/interfaces/speaker';

@Component({
  selector: 'app-persona-short',
  templateUrl: 'persona-short.component.html'
})
export class PersonaShortComponent {
  constructor(
    private modalService: BaseModalService,
  ) {}

  @Output() clickEmitter = new EventEmitter();

  @Input() speaker!:Speaker;

  handleClick():void {
    this.openModal();
  }

  openModal():void {
    const modalRef: ComponentRef<PersonaModalComponent> = this.modalService.open(PersonaModalComponent);

    modalRef.instance.speaker = this.speaker;
  }
}
